module.exports = __webpack_public_path__ + "img/logo.43d9f1f9.svg";